import { API_VERSIONS } from "@/assets/apiDocs/api_constants.js";

import Beta_API, {
  beta_api_category,
  beta_api_menu_by_category,
  beta_api_input_params
} from "@/assets/apiDocs/stock_api_beta.js";
import V2_API, {
  v2_api_category,
  v2_api_menu_by_category,
  v2_api_input_params
} from "@/assets/apiDocs/stock_api_v2.js";


export default {

  state: {
    versions: API_VERSIONS,
    currentVersion: API_VERSIONS[0],

    apiCategoryList: [v2_api_category, beta_api_category],
    apiMenuByCategoryList: [
      v2_api_menu_by_category,
      beta_api_menu_by_category
    ],
    apiContentList: [V2_API, Beta_API],
    apiParamsList: [v2_api_input_params, beta_api_input_params],

    // current variables
    currentApiCategoryList: v2_api_category,
    currentApiMenuByCategoryList: v2_api_menu_by_category,

    currentApiCategory: v2_api_category[0],
    currentApiName: v2_api_menu_by_category[v2_api_category[0]][0],

    currentApiContent: {},
    currentApiParams: {}
  },

  mutations: {
    initDocumentation(state, params) {
      // console.log("[api-docs-service] initDocumentation() params are: ", params);
      // Step 0: get path params
      const { version, api } = params;

      // Step 1: check api version
      let currentVersionIndex = state.versions.indexOf(version);
      currentVersionIndex = Math.max(0, currentVersionIndex);
      state.currentVersion = state.versions[currentVersionIndex];
      state.currentApiCategoryList = state.apiCategoryList[currentVersionIndex];
      state.currentApiMenuByCategoryList = state.apiMenuByCategoryList[currentVersionIndex];

      // Step 2: check api name
      let isValidApiName = false;
      for (let cat of state.currentApiCategoryList) {
        if (state.currentApiMenuByCategoryList[cat].indexOf(api) >= 0) {
          console.log("api!!!!! is: ", api);
          state.currentApiName = api;
          state.currentApiCategory = cat;
          isValidApiName = true;
          break;
        }
      }
      // if not valid api name, reset to introduction
      if (!isValidApiName) {
        state.currentApiName = state.currentApiMenuByCategoryList[state.currentApiCategoryList[0]][0];
        state.currentApiCategory = state.currentApiCategoryList[0];
      }
      // Set API Content
      state.currentApiContent = state.apiContentList[currentVersionIndex][api];
      state.currentApiParams = state.apiParamsList[currentVersionIndex][api];

    },

    setVersion(state, version) {
      // console.log("[api-docs-service] setVersion()...", version);
      let currentVersionIndex = API_VERSIONS.indexOf(version);
      currentVersionIndex = Math.max(0, currentVersionIndex);
      state.currentVersion = state.versions[currentVersionIndex];
      state.currentApiCategoryList = state.apiCategoryList[currentVersionIndex];
      state.currentApiMenuByCategoryList = state.apiMenuByCategoryList[currentVersionIndex];
    },

    setApi(state, params) {
      // console.log("[api-docs-service] setApi()...", params);
      const { apiName, apiCategory } = params;
      state.currentApiName = apiName;
      state.currentApiCategory = apiCategory;
      const i = state.versions.indexOf(state.currentVersion);
      state.currentApiContent = state.apiContentList[i][apiName];
      state.currentApiParams = state.apiParamsList[i][apiName];
    }
  },

  actions: {
    initDocumentation: ({ commit }, params) => commit('initDocumentation', params),
    setVersion: ({ commit }, version) => commit('setVersion', version),
    setApi: ({ commit }, params) => commit('setApi', params)
  }
};


// WEBPACK FOOTER //
// ./src/store/api-docs-service.js